<template>
  <o-table ref="tableList" :enable-delete="false"
           :enable-edit="false" :enable-new="false" :enable-view="false" :extra-row-button="[{icon: 'arrow-right'}]"
           :title="$t('sandoz.kam_verifications')"
           url="/api/sandoz/kam_verifications">
    <template slot="filter">
      <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
        <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="sc.contract_year"></o-filter-select>
        <o-filter-text :title="$t('sandoz.customer_external_id')" column="sc.customer_external_id"></o-filter-text>
        <o-filter-text :title="$t('sandoz.verification_user')" column="su.name" :prepend-percentage="true"></o-filter-text>
        <o-filter-select :items="status" :title="$t('sandoz.status')" column="sandoz_contract_kam_line_verifications.status"></o-filter-select>
        <o-filter-text :title="$t('sandoz.contract_no')" column="sc.contract_no"></o-filter-text>
        <o-filter-text :title="$t('sandoz.responsible_sales_person')" column="sc.responsible_sales_person"></o-filter-text>
        <o-filter-select :items="types" :title="$t('sandoz.contract_type')" column="sc.type">
        </o-filter-select>
        <o-filter-select :items="contractStatus" :title="$t('sandoz.contract_status')" column="contract_status">
        </o-filter-select>
      </o-filter>
    </template>
    <template slot="head">
      <o-table-header column="contract_year">{{ $t('sandoz.contract_year') }}</o-table-header>
      <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
      <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
      <o-table-header column="sc.responsible_sales_person">{{ $t('sandoz.responsible_sales_person') }}</o-table-header>
      <o-table-header column="contract_status">{{ $t('sandoz.contract_status') }}</o-table-header>
      <o-table-header column="name">{{ $t('sandoz.verification_user') }}</o-table-header>
      <o-table-header column="product_name">{{ $t('sandoz.product_name') }}</o-table-header>
      <o-table-header column="company_name">{{ $t('sandoz.company_name') }}</o-table-header>
      <o-table-header column="status">{{ $t('sandoz.status') }}</o-table-header>
      <o-table-header column="planned_verification">{{ $t('sandoz.planned_verification') }}</o-table-header>
      <o-table-header column="actual_verification">{{ $t('sandoz.actual_verification') }}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.contract_year }}</td>
      <td>{{ props.item.contract_no }}</td>
      <td>{{ props.item.customer_external_id }}</td>
      <td>{{ props.item.responsible_sales_person }}</td>
      <td>{{ props.item.contract_status }}</td>
      <td>{{ props.item.name }}</td>
      <td>{{ props.item.product_name }}</td>
      <td>{{ props.item.company_name }}</td>
      <td>
        <span v-if="props.item.status" :class="badge(props.item.status)" class="badge">
          {{ $t('sandoz.' + props.item.status.toLowerCase()) }}
        </span>
      </td>
      <td nowrap="nowrap">{{ props.item.planned_verification | formatDatetime }}</td>
      <td nowrap="nowrap">{{ props.item.actual_verification | formatDatetime }}</td>
    </template>
  </o-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { contractYears } from '../../utils/contractYear'

export default {
  data: () => ({
    years: [],
    status: [],
    stateBadge: {},
    types: [],
    contractStatus: []
  }),
  created () {
    this.years = contractYears()

    this.status = [
      { value: 'pending', text: this.$i18n.t('sandoz.pending') },
      { value: 'verified', text: this.$i18n.t('sandoz.verified') },
      { value: 'failed', text: this.$i18n.t('sandoz.failed') }
    ]

    this.stateBadge = {
      'pending': 'badge-primary',
      'verified': 'badge-success',
      'failed': 'badge-danger'
    }
    this.types = [
      { value: 'KAM_APO', text: this.$i18n.t('sandoz.kam_apo') },
      { value: 'KAM_SD', text: this.$i18n.t('sandoz.kam_sd') },
      { value: 'KAM_HOSP', text: this.$i18n.t('sandoz.kam_hosp') },
      { value: 'KAM_WHS', text: this.$i18n.t('sandoz.kam_whs') },
      { value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget') },
      { value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu') },
      { value: 'BIOS_KAM_APO', text: this.$i18n.t('sandoz.bios_kam_apo')},
      { value: 'BIOS_KAM_WHS', text: this.$i18n.t('sandoz.bios_kam_whs')}
    ]
    this.contractStatus = [
      {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
      {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
      {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
      {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
      {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
      {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')},
      {value: 'Approved', text: this.$i18n.t('sandoz.approved')}
    ]
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    badge (state) {
      if (!state) {
        return
      }
      return this.stateBadge[state]
    }
  }
}
</script>
